import React from 'react';
import { useNavigate } from 'react-router-dom';
import './tiles.scss';

function CourseTile(course) {
    const navigate = useNavigate();

    return (
        <div className="summary-container">
            <div className="summary-container--image-holder">
                <img src={course.image} alt={course.title} />
            </div>
            <div className="summary-container--text-holder">
                <h1 className="title">{course.title}</h1>
                <hr className="dashed-line" />
                <p className="content">{course.content}</p>
                <div className="summary-container--button-holder">
                    <button 
                        className="btn btn-light border rounded-pill" 
                        onClick={() => navigate(`/course/${course.code}/${encodeURIComponent(course.title)}`)}
                    >
                        More Information
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CourseTile;
